export class ListIngestionPipelinePartitionsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "partitions",
            "baseName": "partitions",
            "type": "Array<IngestionPartition>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListIngestionPipelinePartitionsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
